import { TranslationsDE } from './de'
import { TranslationsFR } from './fr'

export type Translations = TranslationsDE | TranslationsFR

//! Note: it is *extremely* important that the publication in this file is
//! read directly from an environment variable, as this is used to force the
//! bundler to exclude the unused translation file at build time.
//! If we read it from the config it will not work, and both files will be bundled.
let translations: Translations
if (process.env.NEXT_PUBLIC_PUBLICATION === 'romandie') {
  /* eslint-disable-next-line @typescript-eslint/no-require-imports */
  translations = require('./fr').default
} else {
  /* eslint-disable-next-line @typescript-eslint/no-require-imports */
  translations = require('./de').default
}
function translate<T extends keyof Translations>(
  key: T,
  args?: Record<string, string>
): Translations[T] {
  if (!args) {
    return translations[key] ?? ''
  }

  const res = translations[key].replace(
    /{{(.+?)}}/g,
    (_: any, argsKey: string) => {
      const res = args[argsKey] || ''
      return res
    }
  ) as Translations[T]

  return res
}

export default translate
